import { QuestBookCard } from '../../components/QuestBookCard'
import { useHomeView } from '../../hooks/useHomeView'
import { BlockSkeleton } from '../BlockSkeleton'

/**
 * `QuestBookCard` existia implementado e sem nenhum importador. Este bloco é o
 * que finalmente o leva ao participante — as cinco props saem inteiras de
 * `useHomeView`, sem adaptação.
 */
export const QuestBookBlock = () => {
  const {
    featured,
    nextMissions,
    journeysProgress,
    missionsTotal,
    hasJourneys,
    isLoading
  } = useHomeView()

  if (isLoading) return <BlockSkeleton rows={3} />

  return (
    <QuestBookCard
      featured={featured}
      nextMissions={nextMissions}
      journeysProgress={journeysProgress}
      missionsTotal={missionsTotal}
      hasJourneys={hasJourneys}
    />
  )
}
